import React, { useContext } from "react";
import styled from "styled-components";
import { Flex, Box } from "reflexbox";

import { Link } from "../Link";
import * as colors from "../../styles/colors";
import { parseMarkdownLinks } from "./parseMarkdownLinks";
import { CrownPriceContext } from "./MdxProvider";

const HeroCard = styled(Box)`
  background: #0c0f14;
  border: 1px solid rgba(42, 199, 220, 0.1);
  border-radius: 16px;
  padding: 28px 32px;

  @media (max-width: 640px) {
    padding: 22px 20px;
    border-radius: 12px;
  }
`;

const ExternalCta = styled.a`
  padding: 12px 24px;
  font-weight: 400;
  font-size: 18px;
  border-radius: 8px;
  border: 1px solid rgba(106, 209, 228, 0.32);
  display: inline-flex;
  text-decoration: none;
  width: fit-content;
  transition: all 0.3s ease-out;
  background: transparent;

  span {
    background: radial-gradient(
      117.29% 1278% at 107.91% 94.25%,
      #0068c6 0%,
      #82fcff 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-box-decoration-break: clone;
    text-shadow: 0px 0px #00000000;
  }

  &:hover {
    border: 1px solid transparent;
    background: ${colors.backgroundNavItem};
  }

  &:hover span {
    background-size: 0% 100%;
    background-repeat: no-repeat;
    background-color: ${colors.primaryGreen};
    animation: stripes 0.3s ease-in 1 forwards;
    -webkit-text-fill-color: transparent;
  }

  @keyframes stripes {
    to {
      background-size: 100% 100%;
    }
  }
`;

function isExternalUrl(href) {
  return (
    href && (href.startsWith("http://") || href.startsWith("https://"))
  );
}

export function GuideHero({ hero, heroCta }) {
  const crownPrice = useContext(CrownPriceContext);
  const opts = { crownPrice };
  if (!hero) return null;

  const ctaHref = heroCta?.href || "#";
  const isExternal = isExternalUrl(ctaHref);

  return (
    <HeroCard mb={[30, 44]}>
      {hero.answer ? (
        <Box
          fontSize={[17, 19]}
          fontWeight={600}
          color={colors.primary}
          style={{ lineHeight: "165%" }}
          mb={hero.detail ? [14] : 0}
        >
          {parseMarkdownLinks(hero.answer, opts)}
        </Box>
      ) : null}

      {hero.detail ? (
        <Box
          fontSize={[15, 16]}
          color={colors.text}
          style={{ lineHeight: "175%" }}
        >
          {parseMarkdownLinks(hero.detail, opts)}
        </Box>
      ) : null}

      {hero.subtitle && !hero.detail ? (
        <Box
          fontSize={[15, 16]}
          color={colors.text}
          style={{ lineHeight: "175%" }}
        >
          {hero.subtitle}
        </Box>
      ) : null}

      {heroCta ? (
        <Flex mt={[22]} flexDirection="column" alignItems="flex-start">
          {isExternal ? (
            <ExternalCta
              href={ctaHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{heroCta.label}</span>
            </ExternalCta>
          ) : (
            <Link to={ctaHref} type="buttonSecondary">
              {heroCta.label}
            </Link>
          )}
          {heroCta.subtext ? (
            <Box
              mt={["8px"]}
              fontSize={[12, 13]}
              color={colors.muted}
              style={{ opacity: 0.8 }}
            >
              {heroCta.subtext}
            </Box>
          ) : null}
        </Flex>
      ) : null}
    </HeroCard>
  );
}
